<div class="flex flex-col h-screen">
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Promoções</h1>
      </div>
      <div class="flex gap-2">
        <button
          type="button"
          (click)="createPromotion()"
          class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded"
        >
          Nova promoção
        </button>
      </div>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (keyup.enter)="getData()"
        placeholder="Buscar..."
        class="border border-gray-300 rounded px-3 py-2 text-sm"
      />
      <button
        type="button"
        (click)="getData()"
        class="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded text-sm w-fit"
      >
        Buscar
      </button>
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} promoção(ões)
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table
        [value]="promotions"
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-4 py-3">Id</th>
            <th class="text-left px-4 py-3">Descrição</th>
            <th class="text-left px-4 py-3">Válida até</th>
            <th class="text-left px-4 py-3">Desconto</th>
            <th class="text-left px-4 py-3">Ativa</th>
            <th class="text-left px-4 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-p let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-4 py-2 font-mono">{{ p.id }}</td>
            <td class="px-4 py-2">{{ p.description || '—' }}</td>
            <td class="px-4 py-2">{{ formatDate(p.validUntil) }}</td>
            <td class="px-4 py-2">
              {{ discountLabel(p.discountType) }}: {{ p.discountValue | number: '1.2-2' }}
            </td>
            <td class="px-4 py-2">{{ p.active ? 'Sim' : 'Não' }}</td>
            <td class="px-4 py-2 flex gap-1">
              <p-button icon="pi pi-pencil" text severity="secondary" (click)="edit(p)"></p-button>
              <p-button icon="pi pi-trash" text severity="danger" (click)="remove(p)"></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">Nenhuma promoção encontrada</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator"
      ></p-paginator>
    </div>
  </div>
</div>
